import {HttpService} from "../HttpService";
import AssignmentsExpressionBuilder from "./AssignmentsExpressionBuilder";

class AssignmentsService {
    getAllAssignments(sortOptions) {

        return new Promise((resolve, reject) => {
            const expression = AssignmentsExpressionBuilder
                .withSortOptions(sortOptions)
                .toExpression();

            HttpService
                .create()
                .get(`api/assignments?${expression}`)
                .then(result => resolve(result.data),
                    err => reject(err));
        });
    }
}

const svc = new AssignmentsService();

export default svc;